import styled from "styled-components";

export const InputStyled = styled.input`
  padding: 5px 10px;

  border: 1px solid rgba(121,101,80,0.41);
`
